import { render, staticRenderFns } from "./FmCheckboxGroup.vue?vue&type=template&id=d6dc6dc0&"
import script from "./FmCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./FmCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./FmCheckboxGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports